


<template>
    <div class="pt-3 pl-5 pr-5">
        <div class="mb-2">
            <breadCrumb :routesArray="routesArray"></breadCrumb>
        </div>
        
        <div class="row w-full justify-between flex" style="align-items: center">
            <h1 class="title">{{ riskName }}</h1>
            <div class="cardbody">
                <div class="flex flex-row-reverse items-center">
                    <div class="flex flex-row-reverse items-center">
                        <button class="flex" @click="filterOpen" :class="riskAcceptanceObj.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'">
                            <img v-if="riskAcceptanceObj.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
                            <img v-else src="@/assets/filter.svg" class="filterIcon" />
                            Filters
                        </button>
                        <!-- <button class="btnprimary mr-2 flex items-center" >Risk History</button> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 text-xs">
            <div>
            Risk management is the process of identifying, assessing and controlling financial, legal, strategic and security risks to an organization’s capital and earnings. These threats, or risks, could stem from a wide variety of sources, including financial uncertainty, legal liabilities,
            strategic management errors, accidents and natural disasters.To reduce risk, an organization needs to apply resources to minimize, monitor and control the impact of negative events while maximizing positive events. A consistent, systemic and integrated approach to risk management can
            help determine how best to identify, manage and mitigate significant risks.
            </div>
        </div>
        <div>
            <newTable :tableRowData="riskAcceptanceObj" :headersData="riskHeaders" :openPopup="true" :loadData="dataLoading"></newTable>
            <div v-if="toolTipActive">
                <tool-tip :tipText="toolTipText"></tool-tip>
            </div>
        </div>

        <popup class="applyPopup" v-if="applyPopup" :popUp="applyPopup">
           
            <div class="flex flex-col h-full">
                <div class="flex-1 overflow-auto">
                    <!--content-->
                    <div class="border-0 rounded relative flex flex-col w-full bg-white risksAcceptance h-screen">
                        <!--header-->
                        <div class="flex items-center justify-between rounded popupheadingcontainer">
                            <h1 v-if="thisScreen == 'Acceptance'">Risk Accept</h1>
                            <h1 v-if="thisScreen == 'reset'">Risk Reset</h1>
                            <h1 v-if="thisScreen == 'deactive'">Risk Invalid</h1>
                            <h1 v-if="thisScreen == 'Avoid'">Risk Avoid</h1>
                            <h1 v-if="thisScreen == 'Transfer'">Risk Transfer</h1>
                            <h1 v-if="thisScreen == 'Monitered'">Risk Moniter</h1>
                            <button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCrossbtn()">
                                <!-- <XIcon class="h-5 w-5" /> -->
                                <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                            </button>
                        </div>
                        <div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
                        <div>
                        <div>
                            <div class="impactcontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div class="row flex flex-col">
                                        <div class="upperspacing">
                                            <label class="controllabel" v-if="systemHead">Systems</label>
                                            <label class="controllabel" v-if="processHead">Process</label>
                                            <label class="controllabel" v-if="organizationHead">Organization</label>
                                           <div class="text-xs flex flex-wrap">
                                                <div v-for="obj,index in mainSystemBind" :key="index" class="mr-2 mb-2 bg-primary text-white px-2 py-1 rounded fontStyle">
                                                    {{obj.label}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="border-b border-solid border-lightgrey upperspacing"></div>
                                        <div class="w-full upperspacing">
                                            <label v-if="thisScreen == 'Acceptance'" class="controllabel">Treatment Summary for Accepting Risk</label>
                                            <label v-if="thisScreen == 'reset'" class="controllabel">Treatment Summary for Reset Risk</label>
                                            <label v-if="thisScreen == 'deactive'" class="controllabel">Treatment Summary for Invalid Risk</label>
                                            <label v-if="thisScreen == 'Avoid'" class="controllabel">Treatment Summary for Avoid Risk </label>
                                            <label v-if="thisScreen == 'Transfer'" class="controllabel">Treatment Summary for Transfer Risk </label>
                                            <label v-if="thisScreen == 'Monitered'" class="controllabel">Treatment Summary for Monitered Risk</label>
                                            <textarea type="text" class="inputboxstyling h-20 max-h-48" v-model.trim="applyObj.comments" placeholder="Treatment Summary"
                                             :class="{
                                                    'is-invalid': (v$.applyObj.comments.$error)
                                                }">
                                            </textarea>
                                            <div v-if="v$.applyObj.comments.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.applyObj.comments.required.$invalid">Required</div>
                                            </div>
                                        </div>
                                        <div v-if="thisScreen!='Avoid' && thisScreen!='reset'&& thisScreen!='deactive'&& (thisScreen!='Monitered' && residualData.statusCode!=10425)">
                                        <h1 class="upperspacing">Revised Impact</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Strategic</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.business"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.business.$error,'inputboxstylingForSelectAtPopup': riskThreatData.business === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbBussiness" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.business"
                                                    :options="dbBussiness"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.business.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.business.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Financial</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.financial"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.financial.$error,'inputboxstylingForSelectAtPopup': riskThreatData.financial === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.financial !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbFinancial" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.financial"
                                                    :options="dbFinancial"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.financial.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.financial.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Operations</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.operations"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.operations.$error,'inputboxstylingForSelectAtPopup': riskThreatData.operations === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbOperations" :key="option" :value="option.value">
                                                        {{ option?.key }}
                                                    </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.operations"
                                                    :options="dbOperations"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.operations !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.operations.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.operations.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Compliance</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.legal"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.legal.$error,'inputboxstylingForSelectAtPopup': riskThreatData.legal === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLegal" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.legal"
                                                    :options="dbLegal"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.legal !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.legal.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.legal.required.$invalid">Required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-6/12 upperspacing">
                                            <label class="controllabel">Overall Impact</label>
                                            <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                <option value="" selected hidden>Please select one</option>
                                                <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <Select
                                                v-model="residualData.overallImpact"
                                                :options="dbOverAllImpact"
                                                disabled
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="custom-multiselect w-full"
                                            />
                                        </div>

                                        <h1 class="upperspacing">Revised Likelihood</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            
                                                <div class="w-6/12">
                                                <label class="controllabel">Likelihood</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.likelihood"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.likelihood.$error,'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                    }"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLikelihood" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.likelihood"
                                                    :options="dbLikelihood"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    placeholder="Please select one"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.likelihood !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.likelihood.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.likelihood.required.$invalid">Required</div>
                                                </div>
                                                </div>
                                                
                                            
                                        </div>
                                        <h1 class="upperspacing">Risk Severity</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                        <div class="w-6/12 upperspacing">
                                            <label class="controllabel">Severity</label>
                                            <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                <option value="" selected hidden>Please select one</option>
                                                <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <Select
                                                v-model="residualData.severity"
                                                :options="dbSeverity"
                                                disabled
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="custom-multiselect w-full"
                                            />
                                        </div>
                                        </div>
                                        <div v-else-if="(thisScreen=='Monitered' && residualData.statusCode==10425)">
                                        <h1 class="upperspacing">Revised Impact</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Strategic</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.business"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.business.$error,'inputboxstylingForSelectAtPopup': riskThreatData.business === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbBussiness" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.business"
                                                    :options="dbBussiness"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.business.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.business.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Financial</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.financial"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.financial.$error,'inputboxstylingForSelectAtPopup': riskThreatData.financial === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.financial !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbFinancial" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.financial"
                                                    :options="dbFinancial"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.financial.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.financial.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Operations</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.operations"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.operations.$error,'inputboxstylingForSelectAtPopup': riskThreatData.operations === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbOperations" :key="option" :value="option.value">
                                                        {{ option?.key }}
                                                    </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.operations"
                                                    :options="dbOperations"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.operations !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.operations.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.operations.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Compliance</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.legal"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.legal.$error,'inputboxstylingForSelectAtPopup': riskThreatData.legal === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLegal" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.legal"
                                                    :options="dbLegal"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.legal !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.legal.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.legal.required.$invalid">Required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-6/12 upperspacing">
                                            <label class="controllabel">Overall Impact</label>
                                            <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                <option value="" selected hidden>Please select one</option>
                                                <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <Select
                                                v-model="residualData.overallImpact"
                                                :options="dbOverAllImpact"
                                                disabled
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="custom-multiselect w-full"
                                            />
                                        </div>

                                        <h1 class="upperspacing">Revised Likelihood</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            
                                                <div class="w-6/12">
                                                <label class="controllabel">Likelihood</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.likelihood"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.likelihood.$error,'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                    }"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLikelihood" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.likelihood"
                                                    :options="dbLikelihood"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    placeholder="Please select one"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.likelihood !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.likelihood.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.likelihood.required.$invalid">Required</div>
                                                </div>
                                                </div>
                                                
                                            
                                        </div>
                                        <h1 class="upperspacing">Risk Severity</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                        <div class="w-6/12 upperspacing">
                                            <label class="controllabel">Severity</label>
                                            <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                <option value="" selected hidden>Please select one</option>
                                                <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <Select
                                                v-model="residualData.severity"
                                                :options="dbSeverity"
                                                disabled
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="custom-multiselect w-full"
                                            />
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        </div>
                        <!--footer-->
                    </div>
                </div>
            <div>
            <div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
            <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                <button :disabled="clickOnButton" @click="cancelAceeptResetBtn()" :class="applyObj.comments == '' && (JSON.stringify(residualData) == JSON.stringify(dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'" class="mr-3">Reset</button>
                <button :disabled="clickOnButton" v-if="thisScreen == 'Acceptance'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="createTaskForAction(applyObj, 10403)">Apply</button>
                <button :disabled="clickOnButton" v-if="thisScreen == 'reset'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary" @click="createTaskForAction(applyObj, 10407)">Apply</button>
                <button :disabled="clickOnButton" v-if="thisScreen == 'deactive'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary" @click="createTaskForAction(applyObj, 10404)">Apply</button>
                <button :disabled="clickOnButton" v-if="thisScreen == 'Avoid'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary" @click="createTaskForAction(applyObj, 10419)">Apply</button>
                <button :disabled="clickOnButton" v-if="thisScreen == 'Monitered'" :class="applyObj.comments == '' && (JSON.stringify(residualData) == JSON.stringify(dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="createTaskForAction(applyObj, 10425)">Apply</button>
                <button :disabled="clickOnButton" v-if="thisScreen == 'Transfer'" :class="applyObj.comments == ''&& (JSON.stringify(residualData) == JSON.stringify(dummyresidualData))  ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary" @click="createTaskForAction(applyObj, 10424)">Apply</button>
            </div>
            </div>
            </div>
        </popup>

        <popup v-if="showThreatPopup" :popUp="showThreatPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Risk</h1>
                    <button class="float-right text-3xl" @click="onCrossbtn()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>

            <div class="popup-business">
                <div>
                    <div>
                        <div>
                            <div class="statuscontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Risk</label> 
                                            <textarea class="disabledtextarea" placeholder="Risk" v-model="riskThreatData.riskCategory" disabled />
                                        </div>
                                    </div>

                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-3/6">
                                            <div>
                                                <label class="controllabel">Threat Source</label>
                                                <input type="text" class="disabledinputboxstyling" v-model="riskThreatData.threatSource" disabled placeholder="Threat Source" />
                                            </div>
                                        </div>
                                        <div class="w-3/6 leftspacing">
                                            <div>
                                                <label class="controllabel">Threat Category</label>
                                                <input type="text" class="disabledinputboxstyling" v-model="riskThreatData.threatCategory" disabled placeholder="Threat Category" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-3/6">
                                            <div>
                                                <label class="controllabel">Risk Category</label>
                                                <input type="text" class="disabledinputboxstyling" v-model="riskThreatData.risk" placeholder="Risk" disabled />
                                            </div>
                                        </div>
                                        <div class="w-3/6 leftspacing">
                                            <div>
                                                <label class="controllabel">Threat Event</label>
                                                <input type="text" class="disabledinputboxstyling" v-model="riskThreatData.threatEvent" placeholder="Threat Event" disabled />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="buttonposition flex justify-center items-center mb-4 mx-0">
                        <button class="filterButton" @click="editRiskThreatData(riskThreatData.mappedRisk, riskThreatData._id)">Edit</button>
                    </div>
                </div>
            </div>
        </popup>

        <popup v-if="openRiskPopup" :popUp="openRiskPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Risk Information</h1>
                    <button class="float-right text-3xl" @click="onCrossbtn()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>
            <div class='flex flex-col h-full'>
                <div class="flex-1 overflow-auto">
                    <div class="popup-business">
                        <div>
                            <div class="statuscontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Risk</label> 
                                            <div v-if="riskThreatData.statusCode==10401">
                                                <textarea
                                                    class="inputboxstyling"
                                                    placeholder="Risk"
                                                    @input ="restrictCharacters('Risk')"
                                                    v-model.trim="riskThreatData.risk"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.risk.$error||displayErrorMessageOfRisk
                                                    }"
                                                />
                                                <div v-if="v$.riskThreatData.risk.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.riskThreatData.risk.required.$invalid">Required</div>
                                                </div>
                                                <div v-else-if="displayErrorMessageOfRisk == true">
                                                    <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                                </div>

                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.risk||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-3/6 ">
                                            <div>
                                                <label class="controllabel">Risk Category</label>
                                                
                                                <!-- <multiselect 
                                                    v-model="riskThreatData.riskCategory"
                                                    :options="riskCategoryList" 
                                                    :searchable="true" 
                                                    :close-on-select="false" 
                                                    :show-labels="false"
                                                    :hide-selected="true"
                                                    placeholder="Risk Category"
                                                    open-direction="bottom"
                                                    class="custom-multiselect"
                                                    :class="{
                                                        'is-invalidmultiselect': v$.riskThreatData.riskCategory.$error,
                                                        'has-options': riskCategoryList && riskCategoryList.length > 0,
                                                        'no-options':  !riskCategoryList.length,
                                                    }"
                                                >
                                                <template v-slot:noResult>
                                                        <span class="text-xs">No Categories Found</span>
                                                    </template>
                                                </multiselect> -->
                                                <div v-if="riskThreatData.statusCode==10401">
                                                 <!-- <Select
                                                    v-model="riskThreatData.riskCategory"
                                                    :options="riskCategoryList"
                                                    placeholder="Risk Category"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.riskCategory.$error,
                                                        'has-options': riskCategoryList && riskCategoryList.length > 0,
                                                        'no-options':  !riskCategoryList.length,

                                                    }"
                                                >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Categories Found</span>
                                                </template>
                                                 </Select> -->
                                                 <AutoComplete
                                                        v-model="riskThreatData.riskCategory"
                                                        :suggestions="searchRiskCategoryList"
                                                        @complete="asyncRiskCategoryDataFind"
                                                        @item-select="selectedRiskCategoryOption"
                                                        placeholder="Risk Category"
                                                        field="label"
                                                        class="w-full"
                                                        :class="{
                                                            'p-invalid': v$.riskThreatData.riskCategory.$error,
                                                            'has-options': searchRiskCategoryList && searchRiskCategoryList.length > 0,
                                                            'no-options': !searchRiskCategoryList.length && searchValue !== '',
                                                        }"
                                                    >
                                                        <template #empty>
                                                            <span class="text-xs">No Categories Found</span>
                                                        </template>
                                                    </AutoComplete>
                                                <div v-if="v$.riskThreatData.riskCategory.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.riskThreatData.riskCategory.required.$invalid">Required</div>
                                                </div>
                                                </div>
                                                <div v-else class="text-sm">
                                                    {{riskThreatData.riskCategory||'N/A'}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-3/6 leftspacing">
                                            <label class="controllabel">Risk Owner</label> 
                                           
                                            <!-- <multiselect
                                                v-model="riskThreatData.riskOwner"
                                                :options="userOptions"
                                                :showNoOptions="false"
                                                @search-change="asyncFind"
                                                :limit-text="limitText"
                                                :multiple="false"
                                                :hide-selected="true"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                open-direction="bottom"
                                                label="label"
                                                track-by="value"    
                                                :searchable="true"
                                                :hideArrow="false"
                                                placeholder="Risk Owner"
                                                class="custom-multiselect userSelect"
                                                :class="{
                                                    'is-invalidmultiselect': v$.riskThreatData.riskOwner.$error,
                                                    'has-options': userOptions && userOptions.length > 0,
                                                    'no-options': !userOptions.length &&  searchValue !== '',
                                                }"
                                            >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Members Found</span>
                                                </template>
                                            </multiselect> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <AutoComplete
                                                    v-model="riskThreatData.riskOwner"
                                                    :suggestions="userOptions"
                                                    @complete="asyncFind"
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    forceSelection
                                                    placeholder="Risk Owner"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'p-invalid': v$.riskThreatData.riskOwner.$error,
                                                        'has-options': userOptions && userOptions.length > 0,
                                                        'no-options': !userOptions.length &&  searchValue !== '',
                                                    }"
                                                >
                                                    <template #empty>
                                                        <span class="text-xs">No Members Found</span>
                                                    </template>
                                                </AutoComplete>
                                            <div v-if="v$.riskThreatData.riskOwner.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.riskOwner.required.$invalid">Required</div>
                                            </div>

                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.riskOwner?.label||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Threat</label> 
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <textarea
                                                class="inputboxstyling"
                                                placeholder="Threat"
                                                @input ="restrictCharacters('Threat')"
                                                v-model.trim="riskThreatData.threatEvent"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.threatEvent.$error||displayErrorMessageOfThreat
                                                }"
                                            />

                                            <div v-if="v$.riskThreatData.threatEvent.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.threatEvent.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="displayErrorMessageOfThreat == true">
                                                <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.threatEvent||'N/A'}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-3/6">
                                            <label class="controllabel">Threat Source</label>
                                            <!-- <multiselect 
                                                v-model="riskThreatData.threatSource"
                                                :options="threatSourceList" 
                                                :searchable="true" 
                                                :close-on-select="false" 
                                                :show-labels="false"
                                                :hide-selected="true"
                                                placeholder="Threat Source"
                                                open-direction="bottom"
                                                class="custom-multiselect"
                                                :class="{
                                                    'is-invalidmultiselect': v$.riskThreatData.threatSource.$error,
                                                    'has-options': threatSourceList && threatSourceList.length > 0,
                                                    'no-options':  !threatSourceList.length,
                                                }"
                                            >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Source Found</span>
                                                </template>
                                            </multiselect> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                             <!-- <Select
                                                v-model="riskThreatData.threatSource"
                                                :options="threatSourceList"
                                                placeholder="Threat Source"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalidmultiselect': v$.riskThreatData.threatSource.$error,
                                                    'has-options': threatSourceList && threatSourceList.length > 0,
                                                    'no-options':  !threatSourceList.length,
                                                }"
                                            >
                                            <template v-slot:noResult>
                                                <span class="text-xs">No Source Found</span>
                                            </template>
                                             </Select> -->
                                             <AutoComplete
                                                        v-model="riskThreatData.threatSource"
                                                        :suggestions="searchThreatSourceList"
                                                        @complete="asyncthreatSourceDataFind"
                                                        @item-select="selectedThreatSourceOption"
                                                        placeholder="Threat Source"
                                                        field="label"
                                                        class="w-full"
                                                        :class="{
                                                            'has-options': searchThreatSourceList && searchThreatSourceList.length > 0,
                                                            'no-options': !searchThreatSourceList.length && searchValue !== '',
                                                        }"
                                                    >
                                                        <template #empty>
                                                            <span class="text-xs">No Source Found</span>
                                                        </template>
                                                    </AutoComplete>
                                             </div>
                                             <div v-else class="text-sm">
                                                {{riskThreatData.threatSource||'N/A'}}
                                             </div>
                                        </div>
                                        <div class="w-3/6 leftspacing">
                                            <label class="controllabel">Threat Category</label>
                                            
                                            <!-- <multiselect 
                                                v-model="riskThreatData.threatCategory"
                                                :options="threatCategoryList" 
                                                :searchable="true" 
                                                :close-on-select="false" 
                                                :show-labels="false"
                                                :hide-selected="true"
                                                placeholder="Risk Category"
                                                open-direction="bottom"
                                                class="custom-multiselect"
                                                :class="{
                                                    'is-invalidmultiselect': v$.riskThreatData.threatCategory.$error,
                                                    'has-options': threatCategoryList && threatCategoryList.length > 0,
                                                    'no-options':  !threatCategoryList.length,
                                                }"
                                            >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Categories Found</span>
                                                </template>
                                            </multiselect> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                             <!-- <Select
                                                v-model="riskThreatData.threatCategory"
                                                :options="threatCategoryList"
                                                placeholder="Risk Category"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.threatCategory.$error,
                                                    'has-options': threatCategoryList && threatCategoryList.length > 0,
                                                    'no-options':  !threatCategoryList.length,

                                                }"
                                            /> -->
                                            <AutoComplete
                                                v-model="riskThreatData.threatCategory"
                                                :suggestions="searchThreatCategoryList"
                                                @complete="asyncthreatCategoryDataFind"
                                                @item-select="selectedOption"
                                                placeholder="Threat Category"
                                                field="label"
                                                class="w-full"
                                                :class="{
                                                    'has-options': searchThreatCategoryList && searchThreatCategoryList.length > 0,
                                                    'no-options': !searchThreatCategoryList.length && searchValue !== '',
                                                }"
                                            >
                                                <template #empty>
                                                    <span class="text-xs">No Categories Found</span>
                                                </template>
                                            </AutoComplete>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.threatCategory}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Vulnerability</label> 
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <textarea
                                                class="inputboxstyling"
                                                placeholder="Vulnerability"
                                                @input ="restrictCharacters('Vulnerability')"
                                                v-model.trim="riskThreatData.vulnerability"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.vulnerability.$error||displayErrorMessageOfVulnerability
                                                }"
                                            />

                                            <div v-if="v$.riskThreatData.vulnerability.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.vulnerability.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="displayErrorMessageOfVulnerability == true">
                                                <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.vulnerability||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Risk Assessment</label>
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <textarea
                                                class="inputboxstyling"
                                                placeholder="Risk Assessment"
                                                @input ="restrictCharacters('Assessment')"
                                                v-model.trim="riskThreatData.riskAssessment"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.riskAssessment.$error||displayErrorMessageOfAssessment
                                                }"
                                            />

                                            <div v-if="v$.riskThreatData.riskAssessment.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.riskAssessment.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="displayErrorMessageOfAssessment == true">
                                                <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.riskAssessment||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <h1 class="upperspacing">Revised Impact</h1>
                                    <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-6/12">
                                            <label class="controllabel">Startegic</label> 
                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.business"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.business.$error,'inputboxstylingForSelectAtPopup': riskThreatData.business === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="option in dbBussiness" :key="option" :value="option.value">
                                                    {{ option.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <Select
                                                v-model="riskThreatData.business"
                                                :options="dbBussiness"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.business.$error,
                                                    'inputboxstylingForSelectAtPopup': riskThreatData.business === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''

                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.business.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.business.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0  && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.business,1) || 'N/A'}}
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.business,1)||'N/A'}}
                                            </div>
                                        </div>

                                        <div class="w-6/12 leftspacing">
                                            <label class="controllabel">Financial</label> 

                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.financial"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.financial.$error,'inputboxstylingForSelectAtPopup': riskThreatData.financial === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.financial !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="option in dbFinancial" :key="option" :value="option.value">
                                                    {{ option.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <Select
                                                v-model="riskThreatData.financial"
                                                :options="dbFinancial"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.financial.$error,
                                                    'inputboxstylingForSelectAtPopup': riskThreatData.financial === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': riskThreatData.financial !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.financial.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.financial.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.financial,2) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.financial,2)}}
                                            </div>
                                        </div>
                                      
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-6/12">
                                            <label class="controllabel">Operations</label> 
                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.operations"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.operations.$error,'inputboxstylingForSelectAtPopup': riskThreatData.operations === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="option in dbOperations" :key="option" :value="option.value">
                                                    {{ option.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <Select
                                                v-model="riskThreatData.operations"
                                                :options="dbOperations"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.operations.$error,
                                                    'inputboxstylingForSelectAtPopup': riskThreatData.operations === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.operations.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.operations.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.operations,3) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.operations,3)||'N/A'}}
                                            </div>
                                        </div>
                                        <div class="w-6/12 leftspacing">
                                            <label class="controllabel">Compliance</label> 
                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.legal"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.legal.$error,'inputboxstylingForSelectAtPopup': riskThreatData.legal === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="option in dbLegal" :key="option" :value="option.value">
                                                    {{ option.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <Select
                                                v-model="riskThreatData.legal"
                                                :options="dbLegal"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.legal.$error,
                                                    'inputboxstylingForSelectAtPopup': riskThreatData.legal === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.legal.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.legal.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.legal,4) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.legal,4)||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-1/2 upperspacing">
                                        <label class="controllabel">Overall Impact</label>
                                        <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                            <option value="" selected hidden>Please select one</option>
                                            <option v-for="i in dbSeverity" :value="i.value" :key="i">
                                                {{ i.key }}
                                            </option>
                                        </select> -->
                                        <div v-if="riskThreatData.statusCode==10401">
                                        <Select
                                            v-model="riskThreatData.overallImpact"
                                            :options="dbSeverity"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            class="custom-multiselect w-full"
                                        />
                                        </div>
                                        <div v-else class="text-sm">
                                            {{lablesData(riskThreatData.overallImpact,6)||'N/A'}}
                                        </div>
                                    </div>
                                    <h1 class="upperspacing">Revised Likelihood</h1>
                                    <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        
                                            <div class="w-1/2">
                                            <label class="controllabel">Likelihood</label> 

                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.likelihood"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.likelihood.$error,'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                }"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="option in dbLikelihood" :key="option" :value="option.value">
                                                    {{ option.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401">
                                            <Select
                                                v-model="riskThreatData.likelihood"
                                                :options="dbLikelihood"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.likelihood.$error,
                                                    'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.likelihood.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.likelihood.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.likelihood,5) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">  
                                                {{lablesData(riskThreatData.likelihood,5)||'N/A'}}
                                            </div>
                                            </div>
                                           
                                        </div>

                                    <h1 class="upperspacing">Risk Severity</h1>
                                    <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                    <div class="w-6/12 upperspacing">
                                        <label class="controllabel">Severity</label>
                                        <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                            <option value="" selected hidden>Please select one</option>
                                            <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                {{ i.key }}
                                            </option>
                                        </select> -->
                                        <Select
                                            v-model="riskThreatData.severity"
                                            :options="dbSeverity"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            class="custom-multiselect w-full"
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="riskThreatData.statusCode==10401">
                <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                    <button :disabled="clickOnButton" class="btnprimary mr-2 gap-2" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelRiskData()">Reset</button>
                    <button :disabled="clickOnButton" class="btnprimary mr-1.5" @click="addOrUpdaterisk(riskThreatData)" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'">Update</button>
                </div>
                </div>
            </div>
        </popup>

        <popup v-if="showPriorityPopUp">
             <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Risk Prioritize</h1>

                    <button class="float-right text-3xl" @click="closePriorityPopup()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>
            <div class='flex flex-col h-full'>
            <div class="flex-1 overflow-auto">
            <div class="popup-priority">
                <div class="w-full popupbodycontainer">
                        <div class=" w-full upperspacing">
                            <label class="controllabel font-normal text-sm mb-1" for="vulnerability">Risk Name</label> 
                            <input 
                                v-model="riskPriorityShow.risk"
                                disabled        
                                placeholder="Name of the Risk"
                                id="id"
                                class="disabledinputboxstyling"
                                :class="{
                                            'is-invalid': v$.riskPriorityShow.risk.$error
                                        }"
                                  
                            />
                            <div class="text-red-500" v-if="v$.riskPriorityShow.risk.$error">
                                <div v-if="v$.riskPriorityShow.risk.required.$invalid" class="error-text text-xs" >Risk name is required</div>
                            </div>
                        </div>

                        <div class=" w-1/2 upperspacing">
                        <label class="controllabel">Priority</label>
                            <!-- <select class="inputboxstyling" v-model="riskPriorityShow.priority">
                                <option v-for="(priority,index) in dbPriority" :key="index" :value="priority.value">{{ priority.key }}</option>
                            </select> -->
                            <Select
                                v-model="riskPriorityShow.priority"
                                :options="dbPriority"
                                optionLabel="key"
                                optionValue="value"
                                class="inputboxstyling w-full"
                            />

                        </div>

                            <div class="text-red-500"  v-if="v$.riskPriorityShow.priority.$error">
                                <div v-if="v$.riskPriorityShow.priority.required.$invalid" class="error-text text-xs" >Please change priority</div>
                            </div>
                        <div v-if="this.riskPriorityShow.priority!==this.priorityDummy.priority">
                            <div class="row flex flex-row w-full">
                                <div class=" w-full upperspacing">
                                    <label for="Risk" class="controllabel">Justification</label> 
                                    <textarea class="inputboxstyling" placeholder="Justification" v-model.trim="riskPriorityShow.justification" :class="{
                                            'is-invalid': v$.riskPriorityShow.justification.$error
                                        }"/>
                                </div>
                            </div>
                            <div class="text-red-500"  v-if="v$.riskPriorityShow.justification.$error">
                                <div v-if="v$.riskPriorityShow.justification.required.$invalid" class="error-text text-xs" >Justification is required</div>
                            </div>
                        </div>
                </div>
                    
            </div>  
            </div>
            <div class="border-b border-solid border-lightgrey mx-5"></div>
            <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                <button :disabled="clickOnButton" class="btnprimary mr-1.5" :class="JSON.stringify(riskPriorityShow) !== JSON.stringify(priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="cancelPriorityBtn()">Reset</button>
                <button :disabled="clickOnButton" @click="addOrUpdatePriority()" :class="JSON.stringify(riskPriorityShow) !== JSON.stringify(priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'">Save</button>
            </div> 
            </div>          
        </popup>
    </div>
</template>
<style scoped>
.borderRed{
    border: 1px solid red !important;
}
.positiontooltip {
    font-size: 12px;
}
.tip {
    display: inline;
}
.flexcontainer {
    overflow-x: hidden;
}
.z-index {
    z-index: 1000;
}
.dropdown {
    position: absolute;
    background-color: white !important;
    color: black;
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
.fontStyle{
    font-size: 14px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import * as XLSX from 'xlsx';
import { required, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { toast } from '@/main';
import popup from '@/components/popup.vue';
import store from '@/store';
import { emitter } from '@/main';
import breadCrumb from '@/components/breadCrumb.vue';
import pagination from '@/components/pagination.vue';
import dropdown from '@/components/dropdown.vue';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import toolTip from '@/components/toolTip.vue';
import { mapGetters } from 'vuex';
import newTable from '@/components/newTable.vue';
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';

export default defineComponent({
    data(): any {
        return {
            v$: useVuelidate(),
            updateArray: [],
            pop: false,
            applyPopup: false,
            searchRiskCategoryList:[],
            searchThreatCategoryList:[],
            searchThreatSourceList :[],
            filterDummy: {
                severity: '',
                statusCode: ''
            },
            xPos: '',
            yPos: '',
            currentSort: 'name',
            currentSortDir: 'asc',
            classSort: '',
            searchValue: '',
            className: '',
            selected: '',
            selectedRowIndex: -1,
            showBlock: false,
            showDropdown: false,
            riskAcceptanceObj: [],
            isMonitored:false,
            dummyresidualData:{},
            residualData:{},
            selectedRisk: { risk: '', severity: '', riskCategory: '' },
            showFilters: false,
            openRiskPopup: false,
            showThreatPopup: false,
            organizationHead: false,
            processHead: false,
            systemHead: false,
            mainTierRiskData: null,
            clickOnButton: false,
            mainSystemBind: [],
            mappedSystemsOptions: [],
            applyObj: {
                comments: ''
            },
            riskHeaders: [],
            optionsValue: [
                {
                    id: 1,
                    value: 'Accept',
                    route: '/riskAcceptance'
                },
                {
                    id: 2,
                    value: 'Mitigate',
                    route: '/mitigateRisk'
                },
                {
                    id: 3,
                    value: 'Reset',
                    route: '/reset'
                },
                {
                    id: 4,
                    value: 'Invalid',
                    route: '/deactive'
                }
            ],

            riskCategoryList: [],
            threatSourceList: [],
            threatCategoryList: [],

            riskThreatData: {
                status: '',
                risk: '',
                threatCategory: '',
                threatSource: '',
                threatEvent: '',
                vulnerability: '',
                business: '',
                operations: '',
                legal: '',
                financial: '',
                likelihood: '',
                riskCategory: '',
                overallImpact: '',
                severity: '',
                riskOwner: '',
                riskAssessment:''
            },
            riskName: '',
            thisScreen: '',
            tasksData: [],
            insertedIds: [],
            risksValue: [
                {
                    id: 10401,
                    value: 'Open'
                },
                {
                    id: 10402,
                    value: 'In Progress'
                },
                {
                    id: 10403,
                    value: 'Accepted'
                },
                {
                    id: 10404,
                    value: 'Deleted'
                },
                {
                    id: 10405,
                    value: 'Mitigated'
                },
                {
                    id: 10406,
                    value: 'Partial'
                }
            ],
            // permissions: [],
            currentPage: '',
            pageSize: '',
            dynamicPagination: '',
            mainSystemRisk: null,
            optionsRiskList: [],
            selectedCategory: [],
            orgUsersList: [],
            optionsUserArray: [],
            riskObjCopy: null,

            mappedSystems: [],
            mappedProcess: [],
            entitiesSelect: [],
            mappedOrganization: [],
            businessProcessList: [],
            routesArray: [],
            presentSystemRiskId: '',
             showPriorityPopUp:false,
            riskPriorityShow:{},
            priorityDummy : {},
            userOptions:[],

            toolTipActive : false,
            toolTipText : '',
            dataLoading:true,
			displayErrorMessageOfRisk : false,
			displayErrorMessageOfThreat : false,
			displayErrorMessageOfVulnerability : false,
            displayErrorMessageOfAssessment:false
        };
    },
    components: {
        popup,
        breadCrumb,
        Multiselect,
        newTable,
        toolTip,
        Select,
        AutoComplete
    },

    computed: {
        ...mapGetters({ userInfo: 'userInfo',dbLikelihood:'dbLikelihood',dbBussiness:'dbBussiness',
            dbOrganization:'dbOrganization',dbOperations:'dbOperations',dbLegal:'dbLegal',
            dbFinancial:'dbFinancial',dbTechnical:'dbTechnical',dbPriority:'dbPriority',dbSeverity: 'dbSeverity',dbOverAllImpact:'dbOverAllImpact'}),

        disableStatus: function (): any {
            let result;
            let objCopy = Object.assign({}, this.riskThreatData);

            if (_.isEqual(objCopy, this.riskObjCopy)) {
                result = false;
            } else {
                result = true;
            }
            return result;
        },
        sortedData: function (): any {
            return [...this.riskAcceptanceObj]
                .filter((row: any) => {
                    for (const key in this.filterDummy) {
                        const inputValue = this.filterDummy[key];
                        if (inputValue !== '' && row[key]) {
                            if (Number.isInteger(row[key])) {
                                if (row[key] !== Number(inputValue)) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        }
    },
    validations() {
        return {
            riskThreatData: {
                risk: { required },
                threatCategory: { required },
                threatSource: { required },
                threatEvent: { required },
                vulnerability: { required },
                riskAssessment:{required},
                business: { required },
                operations: { required },
                legal: { required },
                financial: { required },
                likelihood: { required },
                riskCategory: { required },
                riskOwner: { required }
            },
             applyObj:{
                comments:{required}
            },
            riskPriorityShow:{
                risk:{required},
                priority: { required:requiredIf(()=>{
                    return this.priorityDummy.priority===this.riskPriorityShow.priority;
                })},
                justification:{required}
            },
            residualData: {
                business: { required },
                operations: { required },
                legal: { required },
                financial: { required },
                likelihood: { required },
            },
        };
    },
    
    methods: {
         async calculateOverallImpact(){
            let a1 = this.riskThreatData.business == '' ? 0 : this.riskThreatData.business;
            let a2 = this.riskThreatData.operations == '' ? 0 : this.riskThreatData.operations;
            let a3 = this.riskThreatData.legal == '' ? 0 : this.riskThreatData.legal;
            let a4 = this.riskThreatData.financial == '' ? 0 : this.riskThreatData.financial;


            let b1 = this.residualData.business == '' ? 0 : this.residualData.business;
            let b2 = this.residualData.operations == '' ? 0 : this.residualData.operations;
            let b3 = this.residualData.legal == '' ? 0 : this.residualData.legal;
            let b4 = this.residualData.financial == '' ? 0 : this.residualData.financial;
            let arr = [a1, a2, a3, a4]

            let avg =  arr.reduce((p: any, c: any) => p + c, 0) / arr.length;
            let residualInfo = [b1,b2,b3,b4];
            let residualAvg =  residualInfo.reduce((p: any, c: any) => p + c, 0) / residualInfo.length;
            this.riskThreatData.overallImpact = Math.max(Math.round(avg), 1);
            this.residualData.overallImpact = Math.max(Math.round(residualAvg), 1);
            if (this.residualData.likelihood) {
                let severityScore = this.residualData.overallImpact * this.residualData.likelihood;
                this.residualData.severity = this.riskSeverity(severityScore);
            }
        },
         asyncRiskCategoryDataFind(query:any) {
            query=query.query
            this.searchValue = query
			query = query.trim();
			if (query == '') {
				this.searchRiskCategoryList = [];
			} else {
				this.searchRiskCategoryList = this.riskCategoryList.filter((item:any) => 
					item?.toLowerCase().includes(query.toLowerCase())
				);
				let isNewOption = !this.riskCategoryList.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.searchRiskCategoryList.push(query);
				}
			}
		},
        selectedRiskCategoryOption(opt:any){
            const selected = opt.value;
			let isNewOption = !this.riskCategoryList.some(
               (item: any) => item.id == selected.id
            );
			isNewOption==true ? this.riskCategoryList.push(selected) : ''
		},
        asyncthreatCategoryDataFind(query:any) {
            query=query.query
            this.searchValue = query
			query = query.trim();
			if (query == '') {
				this.searchThreatCategoryList = [];
			} else {
				this.searchThreatCategoryList = this.threatCategoryList.filter((item:any) => 
					item?.toLowerCase().includes(query.toLowerCase())
				);
				let isNewOption = !this.threatCategoryList.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.searchThreatCategoryList.push(query);
				}
			}
		},
        asyncthreatSourceDataFind(query:any) {
            query=query.query
            this.searchValue = query
			query = query.trim();
			if (query == '') {
				this.searchThreatSourceList = [];
			} else {
				this.searchThreatSourceList = this.threatSourceList.filter((item:any) => 
					item?.toLowerCase().includes(query.toLowerCase())
				);
				let isNewOption = !this.threatSourceList.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.searchThreatSourceList.push(query);
				}
			}
		},
        searchCategory(query: any) {
            query = query.query;
            if(query == ''){
                this.filteredCategories=[]
            }
            else if(query.length > 0){
                this.filteredCategories = this.infoCategoryList.filter((obj:any) =>{
                    return obj.toLowerCase().includes(query)
                });
                let isNewOption = !this.infoCategoryList.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.filteredCategories.push(query);
				}
            }
        },
        limitText (count:any) {
			// return `and ${count} other countries`
		},
		asyncFind(query:any){
            query=query.query
            this.searchValue = query
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.optionsUserArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
        onCancelRiskData() {
            this.riskThreatData = { ...this.riskObjCopy };
                this.displayErrorMessageOfRisk = false
                this.displayErrorMessageOfThreat = false
                this.displayErrorMessageOfVulnerability = false
                this.displayErrorMessageOfAssessment=false
        },
        restrictCharacters(code: any){
            if(code === 'Threat'){
                if(this.riskThreatData.threatEvent.length > 1000){
                this.displayErrorMessageOfThreat = true;
                }else if(this.riskThreatData.threatEvent.length < 1000 || this.riskThreatData.threatEvent.length == 1000){
                    this.displayErrorMessageOfThreat = false;
                }
            } else if(code === 'Risk'){
                if(this.riskThreatData.risk.length > 300){
                    this.displayErrorMessageOfRisk = true;
                }else if(this.riskThreatData.risk.length < 300 || this.riskThreatData.risk.length == 300){
                    this.displayErrorMessageOfRisk = false;
                }
            } else if(code === 'Vulnerability'){
                if(this.riskThreatData.vulnerability.length > 1000){
                    this.displayErrorMessageOfVulnerability = true;
                }else if(this.riskThreatData.vulnerability.length < 1000 || this.riskThreatData.vulnerability.length == 1000){
                    this.displayErrorMessageOfVulnerability = false;
                }
            }else if(code === 'Assessment'){
                if(this.riskThreatData.riskAssessment.length > 1000){
                    this.displayErrorMessageOfAssessment = true;
                }else if(this.riskThreatData.riskAssessment.length < 1000 || this.riskThreatData.riskAssessment.length == 1000){
                    this.displayErrorMessageOfAssessment = false;
                }
            }
            
        },
        lablesData(labelInfo:any,id:number){
            if(id==1){
                let v=this.dbBussiness.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==2){
                let v=this.dbFinancial.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==3){
                let v=this.dbOperations.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==4){
                let v=this.dbLegal.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==5){
                let v=this.dbLikelihood.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==6){
                let v=this.dbOverAllImpact.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
        },
        toggleDropdown(risk: any, index: any, e: any) {
            this.showBlock = !this.showBlock;
            this.selectedRowIndex = index;
            this.mainTierRiskData = risk;
            this.showDropdown = false;
        },
        changeRoute(risk: any, route: any) {
            this.mainTierRiskData = risk;
            this.v$.$reset();
            if (route == '/riskAcceptance' && Object.keys(this.mainTierRiskData).includes('riskOwner')) {
                this.thisScreen = 'Acceptance';

                let popupTierObj:any = {};
                if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                    this.systemHead = true;
                    popupTierObj = { value: this.mainTierRiskData.systemId, label: this.mainTierRiskData.systemName };
                } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                    this.processHead = true;
                    popupTierObj = { value: this.mainTierRiskData.processId, label: this.mainTierRiskData.processName };
                } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                    this.organizationHead = true;
                    popupTierObj = { value: this.mainTierRiskData.orgId, label: this.mainTierRiskData.organizationName };
                }

                if (this.mainTierRiskData.statusCode == 10403 || this.mainTierRiskData.statusCode==10402||this.mainTierRiskData.statusCode==10404|| this.mainTierRiskData.statusCode==10425) {
                    toast.error(`Cannot Accept the Risk in this Status`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainTierRiskData).includes('tasks')) {
                        // let conditionForAccept = this.mainTierRiskData.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForAccept) {
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(popupTierObj);
                            this.mainSystemBind.push(popupTierObj);
                            this.applyObj.systems = [...this.mainSystemBind];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                            this.systemHead = true;
                            let name = this.mainTierRiskData.systemName;
                            let systemTierObj = { value: this.mainTierRiskData.systemId, label: name };
                            this.mappedSystemsOptions.push(systemTierObj);
                            this.mainSystemBind.push(systemTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                            this.processHead = true;
                            let name = this.mainTierRiskData.processName;
                            let processTierObj = { value: this.mainTierRiskData.processId, label: name };
                            this.mappedSystemsOptions.push(processTierObj);
                            this.mainSystemBind.push(processTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                            this.organizationHead = true;
                            let name = this.mainTierRiskData.organizationName;
                            let organizationTierObj = { value: this.mainTierRiskData.orgId, label: name };
                            this.mappedSystemsOptions.push(organizationTierObj);
                            this.mainSystemBind.push(organizationTierObj);
                        }
                        this.applyPopup = true;
                        this.applyObj.systems = [...this.mainSystemBind];
                    }
                }
            } else if (route == '/mitigateRisk' && Object.keys(this.mainTierRiskData).includes('riskOwner')) {
                if (this.mainTierRiskData.statusCode == 10406) {
                    this.thisScreen = 'Mitigate';
                    let systemObj:any = {};
                    const mitigateSystems = [];
                    

                    if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                        systemObj = { value: this.mainTierRiskData.systemId, label: this.mainTierRiskData.systemName }
                        mitigateSystems.push(systemObj.value);
                        localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                        this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'systems', id:this.mainTierRiskData.systemId},query:{systems:true,Risks:true}});

                    }else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                        systemObj = { value: this.mainTierRiskData.processId, label: this.mainTierRiskData.processName }
                        mitigateSystems.push(systemObj.value);
                        localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                        this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'process', id:this.mainTierRiskData.processId},query:{process:true,Risks:true}});
                        
                    }else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                        systemObj = { value: this.mainTierRiskData.orgId, label: this.mainTierRiskData.organizationName }
                        mitigateSystems.push(systemObj.value);
                        localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                        this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'organization', id:this.mainTierRiskData.orgId},query:{organization:true,Risks:true}});

                    }              
                    

                } else if(this.mainTierRiskData.statusCode==10404|| this.mainTierRiskData.statusCode==10425|| this.mainRisk.statusCode==10425 ||this.mainRisk.statusCode==10402 || this.mainRisk.statusCode==10403 || this.mainRisk.statusCode ==10424 || this.mainRisk.statusCode == 10419 ){
                        toast.error(`Cannot Mitigate the Risk in this Status`, {
                            timeout: 5000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }else if (Object.keys(this.mainTierRiskData).includes('tasks')) {
                    let conditionForMitigate = this.mainTierRiskData.tasks.every((taskId: any) => {
                        let a = this.tasksData.find((task: any) => {
                            return task._id == taskId;
                        });
                        return a.statusCode == 10403 || a.statusCode == 10410;
                    });

                    if (this.mainTierRiskData.statusCode != 10402 && this.mainTierRiskData.statusCode != 10406 && conditionForMitigate) {
                        this.thisScreen = 'Mitigate';
                        const mitigateSystems:any = [];

                        if (this.mainTierRiskData.statusCode == 10405 || this.mainTierRiskData.statusCode == 10403|| this.mainTierRiskData.statusCode==10425) {
                            toast.error(`Cannot Mitigate the Risk in this Status`, {
                                timeout: 5000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                        } else {

                            if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                                this.systemHead = true;
                                let name = this.mainTierRiskData.systemName;
                                let systemTierObj = { value: this.mainTierRiskData.systemId, label: name };
                                mitigateSystems.push(systemTierObj.value);
                                localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                                this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'system', id:this.mainTierRiskData.systemId},query:{systems:true,Risks:true}});

                            } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                                this.processHead = true;
                                let name = this.mainTierRiskData.processName;
                                let processTierObj = { value: this.mainTierRiskData.processId, label: name };
                                mitigateSystems.push(processTierObj.value);
                                localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                                this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'process', id:this.mainTierRiskData.processId},query:{process:true,Risks:true}});

                            } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                                this.organizationHead = true;
                                let name = this.mainTierRiskData.organizationName;
                                let organizationTierObj = { value: this.mainTierRiskData.orgId, label: name };
                                mitigateSystems.push(organizationTierObj.value);
                                localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                                this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'org', id:this.mainTierRiskData.orgId},query:{organization:true,Risks:true}});

                            }
                            
                        }
                    } else {
                        toast.error(`Tasks In pending for this Risk`, {
                            timeout: 5000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                } else {
                    this.thisScreen = 'Mitigate';

                    const mitigateSystems = [];

                    if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                        this.systemHead = true;
                        let name = this.mainTierRiskData.systemName;
                        let systemTierObj = { value: this.mainTierRiskData.systemId, label: name };
                        mitigateSystems.push(systemTierObj.value);
                        localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                        this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'system', id:this.mainTierRiskData.systemId},query:{systems:true,Risks:true}});

                    } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                        this.processHead = true;
                        let name = this.mainTierRiskData.processName;
                        let processTierObj = { value: this.mainTierRiskData.processId, label: name };
                        mitigateSystems.push(processTierObj.value);
                        localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                        this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'process', id:this.mainTierRiskData.processId},query:{process:true,Risks:true}});

                    } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                        this.organizationHead = true;
                        let name = this.mainTierRiskData.organizationName;
                        let organizationTierObj = { value: this.mainTierRiskData.orgId, label: name };
                        mitigateSystems.push(organizationTierObj.value);
                        localStorage.setItem(this.mainTierRiskData.mappedRisk, JSON.stringify(mitigateSystems));
                        this.$router.push({name:'systemsControlsMapWithId',params:{riskId: this.mainTierRiskData.mappedRisk, type:'org', id:this.mainTierRiskData.orgId},query:{organization:true,Risks:true}});

                    }
                    
                }
            } else if (route == '/reset' && Object.keys(this.mainTierRiskData).includes('riskOwner')) {
                this.thisScreen = 'reset';
                if (this.mainTierRiskData.statusCode == 10401 || this.mainTierRiskData.statusCode == 10402||this.mainTierRiskData.statusCode==10404 || this.mainTierRiskData.statusCode==10425) {
                    toast.error(`Cannot Reset the Risk in this Status`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    let systemObj:any = {};
                    if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                        this.systemHead = true;
                        systemObj = { value: this.mainTierRiskData.systemId, label: this.mainTierRiskData.systemName }
                    }else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                        this.processHead = true
                        systemObj = { value: this.mainTierRiskData.processId, label: this.mainTierRiskData.processName }
                    }else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                        this.organizationHead = true
                        systemObj = { value: this.mainTierRiskData.orgId, label: this.mainTierRiskData.organizationName }
                    }

                    if (Object.keys(this.mainTierRiskData).includes('tasks')) {
                        // let conditionForReset = this.mainTierRiskData.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForReset) {
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(systemObj);
                            this.mainSystemBind.push(systemObj);
                            this.applyObj.systems = [...this.mainSystemBind];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystemBind.push(systemObj);
                        this.applyObj.systems = [...this.mainSystemBind];
                    }
                }
            } else if (route == '/avoid' && Object.keys(this.mainTierRiskData).includes('riskOwner')) {
                this.thisScreen = 'Avoid';

                let popupTierObj:any = {};
                if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                    this.systemHead = true;
                    popupTierObj = { value: this.mainTierRiskData.systemId, label: this.mainTierRiskData.systemName };
                } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                    this.processHead = true;
                    popupTierObj = { value: this.mainTierRiskData.processId, label: this.mainTierRiskData.processName };
                } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                    this.organizationHead = true;
                    popupTierObj = { value: this.mainTierRiskData.orgId, label: this.mainTierRiskData.organizationName };
                }

                if (this.mainTierRiskData.statusCode == 10403 || this.mainTierRiskData.statusCode == 10402||this.mainTierRiskData.statusCode==10404|| this.mainTierRiskData.statusCode==10425) {
                    toast.error(`Cannot Avoid the Risk in this Status`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainTierRiskData).includes('tasks')) {
                        // let conditionForAvoid = this.mainTierRiskData.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForAvoid) {
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(popupTierObj);
                            this.mainSystemBind.push(popupTierObj);
                            this.applyObj.systems = [...this.mainSystemBind];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                            this.systemHead = true;
                            let name = this.mainTierRiskData.systemName;
                            let systemTierObj = { value: this.mainTierRiskData.systemId, label: name };
                            this.mappedSystemsOptions.push(systemTierObj);
                            this.mainSystemBind.push(systemTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                            this.processHead = true;
                            let name = this.mainTierRiskData.processName;
                            let processTierObj = { value: this.mainTierRiskData.processId, label: name };
                            this.mappedSystemsOptions.push(processTierObj);
                            this.mainSystemBind.push(processTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                            this.organizationHead = true;
                            let name = this.mainTierRiskData.organizationName;
                            let organizationTierObj = { value: this.mainTierRiskData.orgId, label: name };
                            this.mappedSystemsOptions.push(organizationTierObj);
                            this.mainSystemBind.push(organizationTierObj);
                        }
                        this.applyPopup = true;
                        this.applyObj.systems = [...this.mainSystemBind];
                    }
                }
            } else if (route == '/transfer' && Object.keys(this.mainTierRiskData).includes('riskOwner')) {
                this.thisScreen = 'Transfer';

                let popupTierObj:any = {};
                if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                    this.systemHead = true;
                    popupTierObj = { value: this.mainTierRiskData.systemId, label: this.mainTierRiskData.systemName };
                } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                    this.processHead = true;
                    popupTierObj = { value: this.mainTierRiskData.processId, label: this.mainTierRiskData.processName };
                } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                    this.organizationHead = true;
                    popupTierObj = { value: this.mainTierRiskData.orgId, label: this.mainTierRiskData.organizationName };
                }

                if (this.mainTierRiskData.statusCode == 10403 || this.mainTierRiskData.statusCode == 10402||this.mainTierRiskData.statusCode==10404|| this.mainTierRiskData.statusCode==10425) {
                    toast.error(`Cannot Transfer the Risk in this Status`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainTierRiskData).includes('tasks')) {
                        // let conditionForTransfer = this.mainTierRiskData.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForTransfer) {
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(popupTierObj);
                            this.mainSystemBind.push(popupTierObj);
                            this.applyObj.systems = [...this.mainSystemBind];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                            this.systemHead = true;
                            let name = this.mainTierRiskData.systemName;
                            let systemTierObj = { value: this.mainTierRiskData.systemId, label: name };
                            this.mappedSystemsOptions.push(systemTierObj);
                            this.mainSystemBind.push(systemTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                            this.processHead = true;
                            let name = this.mainTierRiskData.processName;
                            let processTierObj = { value: this.mainTierRiskData.processId, label: name };
                            this.mappedSystemsOptions.push(processTierObj);
                            this.mainSystemBind.push(processTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                            this.organizationHead = true;
                            let name = this.mainTierRiskData.organizationName;
                            let organizationTierObj = { value: this.mainTierRiskData.orgId, label: name };
                            this.mappedSystemsOptions.push(organizationTierObj);
                            this.mainSystemBind.push(organizationTierObj);
                        }
                        this.applyPopup = true;
                        this.applyObj.systems = [...this.mainSystemBind];
                    }
                }
            } else if (route == '/deactive') {
                this.thisScreen = 'deactive';
                if (this.mainTierRiskData.statusCode == 10402||this.mainTierRiskData.statusCode==10404|| this.mainTierRiskData.statusCode==10425) {
                    toast.error(`Cannot Invalid the Risk in this Status`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                }
                else{
                let systemObj:any = {};
                if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                    systemObj = { value: this.mainTierRiskData.systemId, label: this.mainTierRiskData.systemName }
                }else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                    systemObj = { value: this.mainTierRiskData.processId, label: this.mainTierRiskData.processName }
                }else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                    systemObj = { value: this.mainTierRiskData.orgId, label: this.mainTierRiskData.organizationName }
                }
                if (Object.keys(this.mainTierRiskData).includes('tasks')) {
                    // let conditionForDelete = this.mainTierRiskData.tasks.every((taskId: any) => {
                    //     let a = this.tasksData.find((task: any) => {
                    //         return task._id == taskId;
                    //     });
                    //     return a.statusCode == 10403 || a.statusCode == 10410;
                    // });
                    // if (conditionForDelete) {
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystemBind.push(systemObj);
                        this.applyObj.systems = [...this.mainSystemBind];
                    // } else {
                    //     toast.error(`Tasks in Pending for this Risk`, {
                    //         timeout: 5000,
                    //         closeOnClick: true,
                    //         closeButton: 'button',
                    //         icon: true
                    //     });
                    // }
                } else {
                    this.applyPopup = true;
                    this.mappedSystemsOptions.push(systemObj);
                    this.mainSystemBind.push(systemObj);
                    this.applyObj.systems = [...this.mainSystemBind];
                }
                }
            } else if (route == '/monitered' && Object.keys(this.mainTierRiskData).includes('riskOwner')) {
                this.thisScreen = 'Monitered';                
                if (this.mainTierRiskData.statusCode == 10403 || this.mainTierRiskData.statusCode == 10402||this.mainTierRiskData.statusCode==10404||this.isMonitored==true) {
                    toast.error(`Cannot Monitered the Risk in this Status`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                      if (Object.keys(this.mainTierRiskData).includes('systemId')) {
                            this.systemHead = true;
                            let name = this.mainTierRiskData.systemName;
                            let systemTierObj = { value: this.mainTierRiskData.systemId, label: name };
                            this.mappedSystemsOptions.push(systemTierObj);
                            this.mainSystemBind.push(systemTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('processId')) {
                            this.processHead = true;
                            let name = this.mainTierRiskData.processName;
                            let processTierObj = { value: this.mainTierRiskData.processId, label: name };
                            this.mappedSystemsOptions.push(processTierObj);
                            this.mainSystemBind.push(processTierObj);

                        } else if (Object.keys(this.mainTierRiskData).includes('orgId')) {
                            this.organizationHead = true;
                            let name = this.mainTierRiskData.organizationName;
                            let organizationTierObj = { value: this.mainTierRiskData.orgId, label: name };
                            this.mappedSystemsOptions.push(organizationTierObj);
                            this.mainSystemBind.push(organizationTierObj);
                        }
                        this.applyPopup = true;
                        this.applyObj.systems = [...this.mainSystemBind];
                }
            } else if(route == '/clone'){
                 if(this.mainTierRiskData.statusCode==10404){
                    toast.error(`Tasks In Invalid for this Risk`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                }else{let tierType:any
                if(risk.tier == 1){
                    tierType = 'organization'
                }else if(risk.tier == 2){
                    tierType = 'process'
                }else if(risk.tier == 3){
                    tierType = 'systems'
                }

                this.$router.push({ name:'cloner',params:{ mappedRisk: risk.mappedRisk, riskId:risk._id, type: tierType },query:{ tierRisks:true } })
                }
            }
        },
        async getRootRiskList() {
            this.optionsRiskList = [];
            this.riskCategoryList = [];
            this.threatCategoryList = [];
            this.threatSourceList = [];

            const result = await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/root/risks/getall?org=true`);
            this.optionsRiskList = result.data;
            this.optionsRiskList.forEach((risk: any) => {
                risk.entityId = 20008;
                !this.riskCategoryList.includes(risk.riskCategory) ? this.riskCategoryList.push(risk.riskCategory) : '';

                !this.threatCategoryList.includes(risk.threatCategory) ? this.threatCategoryList.push(risk.threatCategory) : '';

                !this.threatSourceList.includes(risk.threatSource) ? this.threatSourceList.push(risk.threatSource) : '';
            });
            
        },
        async getBusinessProcess() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
                this.businessProcessList = result.data;
            });
        },
        async addOrUpdaterisk(riskData: any) {
            this.v$.riskThreatData.$touch();
            // this.updateArray.push(riskData);
            if (!this.v$.riskThreatData.$invalid && this.displayErrorMessageOfRisk == false && this.displayErrorMessageOfThreat == false && this.displayErrorMessageOfVulnerability == false&& this.displayErrorMessageOfAssessment== false) {
                this.clickOnButton = true
                let copyOfriskData:any = {...riskData}
                let oldObj: any = {};
                let newObj: any = {};
                Object.keys(riskData).map((key: any) => {
                    if (copyOfriskData[key] != this.riskObjCopy[key] && key != 'updatedValues') {
                        oldObj[key] = this.riskObjCopy[key];
                        newObj[key] = copyOfriskData[key];
                    }
                });
                copyOfriskData.updatedValues = { oldRisk: [], newRisk: [] };
                copyOfriskData.updatedValues.oldRisk.push(oldObj);
                copyOfriskData.updatedValues.newRisk.push(newObj);

                this.updateArray.push(copyOfriskData);
                await this.updateRisk();
                this.openRiskPopup = false;
            } 
            // else {
            //     toast.error(`errorr`, {
            //         timeout: 1000,
            //         closeOnClick: true,
            //         closeButton: 'button',
            //         icon: true
            //     });
            // }
            this.updateArray = [];
        },
        async updateRisk() {
            try {
                let riskId = this.updateArray[0]._id;
                delete this.updateArray[0]._id;
                delete this.updateArray[0].overallImpact;
                delete this.updateArray[0].severity;
                delete this.updateArray[0].comments;
                delete this.updateArray[0].treatmentType;
                this.updateArray[0].updatedAt = new Date();
                this.updateArray[0].updatedBy = this.userInfo._id;
                this.updateArray[0].riskOwner = this.updateArray[0].riskOwner.value

                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/root/risk/${riskId}/update?org==true`, this.updateArray[0]).then((result: any) => {
                    toast.info(`Uploaded succesfully`, {
                        closeOnClick: true,
                        closeButton: 'button'
                    });
                });
                this.showPriorityPopUp = false;
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            } finally {
                this.clickOnButton = false
            }
            await this.getAllSystemsRisks();
        },
        onCrossbtn() {
            this.v$.$reset();
            this.displayErrorMessageOfRisk = false
            this.displayErrorMessageOfThreat = false
            this.displayErrorMessageOfVulnerability = false
            this.openRiskPopup = false;
            // this.showThreatPopup = false;
            this.applyPopup = false;
            this.mappedSystemsOptions = [];
            this.mainSystemBind = [];
            Object.keys(this.applyObj).forEach((prop) => {
                Array.isArray(this.applyObj[prop]) ? (this.applyObj[prop] = []) : (this.applyObj[prop] = '');
            });
        },
        cancelAceeptResetBtn() {
            this.v$.$reset();
            this.applyObj.comments = '';
            this.residualData = JSON.parse(JSON.stringify(this.dummyresidualData));

        },
        editRiskThreatData(mappedriskId: any, riskId: any) {
            this.$router.push({ name: 'riskedit', params: { mappedriskId: mappedriskId, riskId: riskId } });
        },
        getDateFormat(date: any) {
            if (date == '') {
                return 'None';
            } else {
                let now = moment(date);
                return now.format('DD-MM-YYYY');
            }
        },
        showPopup(riskItem: any) {
            this.presentSystemRiskId = riskItem._id;
            this.openRiskPopup = true;
            // this.showThreatPopup = true;
            
            this.riskThreatData = {...riskItem};
            this.riskObjCopy = { ...riskItem };
            this.mainSystemRisk = { ...riskItem };
        },
        async getSystems() {
            let entityId = '20005';
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((result: any) => {
                this.systems = result.data;
                this.dummySystems = result.data;
            });
        },
        async getAllSystemsRisks() {
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/risk/${this.$route.params.riskId}/systems`).then((result: any) => {
                
                let mainTier:any;


                // console.log('RESULT DATAAAAAA',result.data)
                
                if(result.data.length > 0){
                    if(this.$route.path.includes('systemRisks')){
                        mainTier = 3
                    }else if(this.$route.path.includes('processRisks')){
                        mainTier= 2
                    }else if(this.$route.path.includes('orgRisks')){
                        mainTier= 1
                    }
                    
                    

                    let filter:any = result.data.filter((risk: any) => {
                        return risk.tier == mainTier;
                    });
                    
                    this.riskAcceptanceObj = filter;
                }else{
                    this.riskAcceptanceObj = []
                }
                
                
                for (let i = 0; i < this.riskAcceptanceObj.length; i++) {
                    let systemsObj: any = false;
                    systemsObj = Object.keys(this.riskAcceptanceObj[i]).includes('systemId');

                    let processObj: any = false;
                    processObj = Object.keys(this.riskAcceptanceObj[i]).includes('processId');

                    let organizationObj: any = false;
                    organizationObj = Object.keys(this.riskAcceptanceObj[i]).includes('orgId');

                    if (systemsObj == true) {
                        // this.riskHeaders = ['severity', 'systemName', 'createdAt', 'updatedAt', 'statusCode', 'priority','History', 'actionButton'];
                        this.riskAcceptanceObj[i].systemName = this.systems.find((obj: any) => this.riskAcceptanceObj[i].systemId == obj._id).systemName;
                        // this.systems.map((obj: any) => {
                        //     if (this.riskAcceptanceObj[i].systemId == obj._id) {
                        //         this.mappedSystems.push(obj);
                        //     }
                        // });
                        let myObj:any = this.systems.find((obj:any)=>{return this.riskAcceptanceObj[i].systemId == obj._id});
                        if(myObj != undefined){
                            this.mappedSystems.push(myObj);
                        }

                    } else if (processObj == true) {
                        // this.riskHeaders = ['severity', 'processName', 'createdAt', 'updatedAt', 'statusCode',  'priority','History', 'actionButton'];
                        this.riskAcceptanceObj[i].processName = this.businessProcessList.find((obj: any) => this.riskAcceptanceObj[i].processId == obj._id).businessProcessName;
                        // this.businessProcessList.map((obj: any) => {
                        //     if (this.riskAcceptanceObj[i].processId == obj._id) {
                        //         this.mappedProcess.push(obj);
                        //     }
                        // });
                        let myObj:any = this.businessProcessList.find((obj:any)=>{return this.riskAcceptanceObj[i].processId == obj._id});
                        if(myObj != undefined){
                            this.mappedSystems.push(myObj);
                        }
                    } else if (organizationObj == true) {
                        // this.riskHeaders = ['severity', 'organizationName', 'createdAt', 'updatedAt', 'statusCode',  'priority','History', 'actionButton'];
                        this.riskAcceptanceObj[i].organizationName = this.entitiesSelect.find((obj: any) => this.riskAcceptanceObj[i].orgId == obj.value).label;

                        // this.entitiesSelect.map((obj: any) => {
                        //     if (this.riskAcceptanceObj[i].orgId == obj.value) {
                        //         this.mappedOrganization.push(obj);
                        //     }
                        // });
                        let myObj:any = this.entitiesSelect.find((obj:any)=>{return this.riskAcceptanceObj[i].orgId == obj._id});
                        if(myObj != undefined){
                            this.mappedSystems.push(myObj);
                        }
                    }

                    let openList:any = this.riskAcceptanceObj[i];
                    

                    let condition1 = Object.keys(this.riskAcceptanceObj[i]).includes('residual') && this.riskAcceptanceObj[i]['residual'].length > 0;
                    let averageImpact;
                    let impact;
                    let severity;

                    if (condition1 == true) {
                        let lengthOfArray = this.riskAcceptanceObj[i]['residual'].length;
                        let indexObj = this.riskAcceptanceObj[i]['residual'][lengthOfArray - 1];

                        if (indexObj.isActive == true) {
                            averageImpact = this.average([indexObj['business'], indexObj['operations'], indexObj['legal'], indexObj['financial']]);
                            impact = Math.round(averageImpact);
                            severity = this.riskSeverity(impact * indexObj['likelihood']);

                            let arr = [ 'business', 'operations', 'legal', 'financial', 'likelihood'];
                            for (let key of arr) {
                                this.riskAcceptanceObj[i][key] = indexObj[key];
                            }
                        } else {
                            averageImpact = this.average([ openList['business'], openList['operations'], openList['legal'], openList['financial']]);
                            impact = Math.round(averageImpact);
                            severity = this.riskSeverity(impact * openList['likelihood']);
                        }
                    } else if (condition1 == false) {
                        averageImpact = this.average([ openList['business'], openList['operations'], openList['legal'], openList['financial']]);
                        impact = Math.round(averageImpact);
                        severity = this.riskSeverity(impact * openList['likelihood']);
                    };

                    this.riskAcceptanceObj[i].impact = impact;
                    this.riskAcceptanceObj[i].severity = severity;
                    this.riskAcceptanceObj[i].treatmentType = this.riskAcceptanceObj[i].action!=undefined?this.riskAcceptanceObj[i].action : 'N/A';;
                    if (!Object.keys(this.riskAcceptanceObj[i]).includes('updatedAt') && this.riskAcceptanceObj[i].updatedAt != '') {
                        this.riskAcceptanceObj[i].updatedAt = this.riskAcceptanceObj[i].updatedAt||'';
                    }

                    let userobj = this.optionsUserArray.find((obj:any)=>{return obj.value == this.riskAcceptanceObj[i].riskOwner});

                    userobj != undefined ? this.riskAcceptanceObj[i].riskOwner = userobj : this.riskAcceptanceObj[i].riskOwner = ''

                }
                
                this.riskName = this.riskAcceptanceObj[0]?.risk;
                // this.$store.dispatch('updateDotsLoading', false);
            });
            this.getRootRiskList();
        },
        setHeaders() {
            if (this.$route.path.includes('systemRisks')) {
                this.riskHeaders = ['severity', 'systemName', 'createdAt', 'updatedAt','treatmentType', 'statusCode', 'priority', 'History', 'actionButton'];
            } 
            else if (this.$route.path.includes('processRisks')) {
                this.riskHeaders = ['severity', 'processName', 'createdAt', 'updatedAt','treatmentType', 'statusCode', 'priority', 'History', 'actionButton'];
            } 
            else if (this.$route.path.includes('orgRisks')) {
                this.riskHeaders = ['severity', 'organizationName', 'createdAt', 'updatedAt','treatmentType', 'statusCode', 'priority', 'History', 'actionButton'];
            }
        },
        async getAllTasks() {
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/tasks/getall`).then((result: any) => {
                this.tasksData = result.data;
            });
        },
        async getBusinessEntities(){
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((result: any) => {
                this.entitiesSelect = result.data.map((org: any) => {
                    return { value: org._id, label: org.entityName };
                });
            })
        },
        async getallUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.orgUsersList = res.data;
                this.orgUsersList = this.orgUsersList.filter((user: any) => {
                    return user.isActive == true;
                });
                for (var i = 0; i < this.orgUsersList.length; i++) {
                    this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
                }
            });
        },
        async createTaskForAction(applyObj: any, actionCode: any) {
             this.v$.$touch();
            if(!this.v$.applyObj.comments.$invalid){
            this.clickOnButton = true
            let payload: any = [];
            let obj:any = {
                    mappedRisk: this.mainTierRiskData.mappedRisk,
                    createdAt: new Date(),
                    createdBy: this.userInfo._id,
                    action: actionCode
                }
            if(this.$route.path.includes('systemRisks')){
                obj.systems = []
                applyObj.systems.map((item:any)=>{obj.systems.push(item.value)})
                obj.tier = 3
            }else if(this.$route.path.includes('processRisks')){
                obj.process = []
                applyObj.systems.map((item:any)=>{obj.process.push(item.value)})
                obj.tier = 2
            }else if(this.$route.path.includes('orgRisks')){
                obj.org = []
                applyObj.systems.map((item:any)=>{obj.org.push(item.value)})
                obj.tier = 1
            }

            payload.push(obj)
               
            payload[0].comments = applyObj.comments;

            //workflow task initialize
            await this.createWorkFlowTask(payload,actionCode);

            Object.keys(this.applyObj).forEach((prop) => {
                Array.isArray(this.applyObj[prop]) ? (this.applyObj[prop] = []) : (this.applyObj[prop] = '');
            });

            await this.getAllTasks();
            await this.getAllSystemsRisks();

            this.mainSystemBind = [];
        }
        },
        async createActionForRisk(payload: any) {
            try {
                // await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/risk/accept`, payload).then((result: any) => {
                //     // this.systemAssesmentList = result.data;
                // });
                if(payload[0].action==10403 || payload[0].action == 10419 || payload[0].action == 10424 || payload[0].action==10425){
                     const actionNameMap: Record<number, string> = {
                        10403: 'accept',
                        // 10404: 'invalid',
                        10424: 'transfer',
                        10419: 'avoid',
                        10425: 'monitered',
                        // 10407: 'reset'
                    };
                    const actionName = actionNameMap[payload[0].action];
 
                    if (!actionName) {
                        throw new Error('Invalid action');
                    }
                    if(payload[0].treatmentType==10425){
                            this.isMonitored=true
                        }
                     await this.$http.post(`${process.env.VUE_APP_RISK_API}/risk/${actionName}`, payload).then((result: any) => {
                        // console.log('Done');
                    });
                }
                else{
                if(this.residualData.statusCode!=10425){
                    const actionNameMap: Record<number, string> = {
                            10404: 'invalid',
                            10407: 'reset'
                        };
                        const actionName = actionNameMap[payload[0].action];
                        if (!actionName) {
                            throw new Error('Invalid action');
                        } 
                     await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/risk/${actionName}`, payload).then((result: any) => {
                        if(this.thisScreen == 'reset' && payload[0].action==10407){
                        toast.info('Task Reset', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    } if(this.thisScreen == 'deactive' &&payload[0].action==10404){
                        toast.info('Task Deleted', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                       // console.log('Done');
                    });
                }
                }
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        async createWorkFlowTask(payload: any,actionType:any) {
            try {
                //    payload.createdAt=new Date(),
                //    payload.createdBy=this.userInfo._id,
                // ${process.env.VUE_APP_API}
                let residualArr:any;
                let riskJustification = payload[0].comments;
                delete payload[0].comments;
                let action = payload[0].action;
                 if(actionType==10403 || actionType == 10424 || this.residualData.statusCode==10425){
                    residualArr={
                        legal:this.residualData.legal,
                        business:this.residualData.business,
                        financial:this.residualData.financial,
                        operations:this.residualData.operations,
                        likelihood:this.residualData.likelihood
                    }
                 }
                if(actionType==10403 || actionType == 10419 || actionType == 10424|| actionType == 10425){
                    let acceptData:any=[]
                    if(payload[0].systems){
                        let systemObj={  
                            tier:3,
                           treatmentType:action,
                           createdAt:payload[0].createdAt,
                           createdBy:payload[0].createdBy,
                           systems:payload[0].systems,
                           riskId:this.residualData._id,
                           residualRisk: residualArr ? [residualArr] : []
                           }
                           acceptData.push(systemObj)

                    }
                    if(payload[0].process){
                        let activityObj={  
                            tier:2,
                            treatmentType:action,
                            createdAt:payload[0].createdAt,
                            createdBy:payload[0].createdBy,
                            activities:payload[0].process,
                            riskId:this.residualData._id,
                            residualRisk: residualArr ? [residualArr] : []
                        }
                        acceptData.push(activityObj)
                        delete payload[0].process
                    }
                delete payload[0].comments;
                delete payload[0].action,
                delete payload[0].createdBy;
                delete payload[0].createdAt
                payload =acceptData
                }
            if(actionType!=10404 && actionType!=10407){
                if(payload[0].treatmentType && payload[0].treatmentType==10403){
                    payload[0].acceptSummary = riskJustification;
                }
                else if(payload[0].treatmentType && payload[0].treatmentType==10419){
                    payload[0].avoidSummary = riskJustification;
 
                }else if(payload[0].treatmentType && payload[0].treatmentType==10424){
                    payload[0].transferSummary = riskJustification;
 
                }else if(payload[0].treatmentType && payload[0].treatmentType==10425){
                    payload[0].moniteredSummary = riskJustification;

                }else{
                    payload[0].comments = riskJustification;
                }
                await this.$http.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_RISK_WORKFLOW_ACTION_ID}/risk/task`, payload).then((result: any) => {
                    this.insertedIds = result.data;
                    if(this.thisScreen == 'Acceptance'){
                        toast.info('Task Accepted', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    } else if(this.thisScreen == 'Avoid'){
                        toast.info('Task Avoided', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    } else if(this.thisScreen == 'Transfer'){
                        toast.info('Task Transferd', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    } else  {
                        toast.info('Task Created', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                });
                payload[0].insertedIds = [this.insertedIds];
                payload[0].residual =[residualArr];
                // payload[0].comments = riskJustification;
                payload[0].action = action;
                
                if(action==10419|| (action == 10425 && payload[0].residual[0]==undefined)){
                    payload[0].residual=[];
                }
            }
            else{
                if(payload[0].action && payload[0].action==10407){
                    payload[0].resetSummary = riskJustification;
                }
                else if(payload[0].action && payload[0].action==10404){
                    payload[0].invalidSummary = riskJustification;
 
                }else{
                    payload[0].comments = riskJustification;
                }
            }
                if(payload[0].systems){
                    payload[0].tier=3
                }
                if(payload[0].process){
                    payload[0].tier=2;
                }
                await this.createActionForRisk(payload);
                this.applyPopup = false;
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            } finally {
                this.clickOnButton = false
            }
        },
        riskSeverity(value: number) {
            if (value <= 3) {
                return 1;
            } else if (value > 3 && value <= 8) {
                return 2;
            } else if (value > 8 && value <= 12) {
                return 3;
            } else if (value > 12 && value <= 16) {
                return 4;
            } else if (value > 16 && value <= 25) {
                return 5;
            }
        },
        
        filterOpen() {
            this.showFilters = !this.showFilters;
            if (this.showFilters == true) {
                this.dummyList = this.riskAcceptanceObj;
            } else {
                this.riskAcceptanceObj = this.dummyList;
                for (const key in this.filterDummy) {
                    this.filterDummy[key] = '';
                }
            }
            emitter.emit('visible', this.showFilters);
        },
        average(arr: any[]) {
            return arr.reduce((p, c) => p + c, 0) / arr.length;
        },
        showPriorityPopUpAction(data: any) {
            this.mainTierRiskData = {...data};
            this.riskObjCopy = {...data}

            this.showPriorityPopUp = true;

            this.riskPriorityShow.risk=data.risk;
            this.riskPriorityShow.priority=data.priority;
            this.riskPriorityShow.justification = '';

            this.priorityDummy.risk=data.risk;
            this.priorityDummy.priority=data.priority;
            this.priorityDummy.justification = ''
        },

        closePriorityPopup() {
            this.resetRiskPriority();
            this.showPriorityPopUp = false;
        },

        cancelPriorityBtn() {
            this.riskPriorityShow.risk=this.priorityDummy.risk;
            this.riskPriorityShow.priority=this.priorityDummy.priority;
            this.riskPriorityShow.justification='';
            this.priorityDummy.justification='';
            this.v$.$reset();
        },

        async addOrUpdatePriority() {
            this.v$.$touch();
            if (!this.v$.riskPriorityShow.$invalid) {
                this.clickOnButton = true
                
                this.mainTierRiskData.priority = this.riskPriorityShow.priority;
                this.mainTierRiskData.priorityComments = this.riskPriorityShow.justification;
                
                let riskData = {...this.mainTierRiskData}

                let oldObj: any = {};
                let newObj: any = {};
                Object.keys(riskData).map((key: any) => {
                    if (riskData[key] != this.riskObjCopy[key] && key != 'updatedValues' && key !='priorityComments') {
                        oldObj[key] = this.riskObjCopy[key];
                        newObj[key] = riskData[key];
                    }
                });
                riskData.updatedValues = { oldRisk: [], newRisk: [] };
                riskData.updatedValues.oldRisk.push(oldObj);
                riskData.updatedValues.newRisk.push(newObj);

                this.updateArray = [];

                this.updateArray.push(riskData);
                //updatingRisk
                await this.updateRisk();

                this.v$.$reset();
            }else {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }

        },

        resetRiskPriority() {
            this.riskPriorityShow.risk = '';
            this.riskPriorityShow.priority = null;
            this.riskPriorityShow.justification='';
            // this.riskPriorityShow._id=null;
            this.priorityDummy.risk = '';
            this.priorityDummy.priority = null;
            this.priorityDummy.justification='';
            // this.priorityDummy._id=null;
            this.v$.$reset();
        },
    },
  
    async created(){
        // this.riskHeaders = ['severity', '', 'createdAt', 'updatedAt', 'statusCode', 'priority','History', 'actionButton'];
        this.setHeaders();
        this.dataLoading = true;

        await this.getallUsers();
        await this.getSystems();

        await this.getBusinessProcess();
        await this.getBusinessEntities();
        
        await this.getAllTasks();
        await this.getAllSystemsRisks();

        this.dataLoading = false;
    },
    async mounted() {
        //this.$store.dispatch('updateDotsLoading', true);
        let id = this.$route.params.id;
        this.routesArray = [
            { name: 'Risks', routeName: 'risks' },
            { name: 'Tier-Risks', routeName: 'tierRisks', id: `${id}` }
        ];
        
        emitter.on('*', (type, booleanValue) => {
            if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
                this.showBlock == true ? (this.showBlock = false) : '';
            } else {
                if (this.showDropdown === true) {
                    this.showBlock == true ? (this.showBlock = booleanValue) : '';
                } else if (this.showDropdown === false) {
                    this.showBlock == true ? '' : (this.showBlock = booleanValue);
                    this.showDropdown = true;
                }
            }
        });

        emitter.off('showData123');
        emitter.on('showData123', (isData: any) => {
            let comingId = isData.entityData._id;
            let showObj = this.riskAcceptanceObj.find((obj: any) => {
                return obj._id === comingId;
            });
            this.showPopup(showObj);
        });

        emitter.off('showPriorityPopup');
        emitter.on('showPriorityPopup', (isData: any) => {
            this.showPriorityPopUpAction(isData);
        } );

        emitter.off('changeRouteInTierRisks');
        emitter.on('changeRouteInTierRisks', (selectedActionObj: any) => {
            let risk = selectedActionObj.data;
            let route = selectedActionObj.route;
            this.residualData = {...risk};
            this.dummyresidualData={...risk}
            this.changeRoute(risk, route);
        });

        emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });
    }
});
</script>

